export function hasAuthorities(label) {
     const groupAuthorities = JSON.parse(localStorage.getItem('groupAuthorities')) || [];
     const personalAuthorities = JSON.parse(localStorage.getItem('personalAuthorities')) || [];

     const groupMatch = Array.isArray(groupAuthorities) && groupAuthorities.some(authorityObject =>
        Array.isArray(authorityObject.groupAuthorities) &&
        authorityObject.groupAuthorities.some(authority => authority.label === label)
    );

     const personalMatch = Array.isArray(personalAuthorities) && personalAuthorities.some(authority =>
        authority.label === label
    );

     return !!(groupMatch || personalMatch);
}

// Routes protégées par une autorité, dans l'ordre de préférence pour l'atterrissage après connexion
// (même table que PrivateRoute). Un expert n'a que VIEW_CLAIM_LIST / VIEW_TO_DO_LIST → /sinistres.
export const RESTRICTED_ROUTES = {
    '/dashboard': 'VIEW_DASHBOARD',
    '/sinistres': 'VIEW_CLAIM_LIST',
    '/todo-list': 'VIEW_TO_DO_LIST',
    '/experts': 'VIEW_EXPERTS_LIST',
    '/SettlementEligibleClaim': 'VIEW_CLAIMS_ELIGIBLE_FOR_PAYMENT_LIST',
    '/ClaimToBeLoadedToPlatform': 'VIEW_LIST_CLAIM_ERECOURS',
    '/users': 'VIEW_USERS_LIST',
    '/services': 'VIEW_SERVICE_PROPOSAL_LIST',
    '/user-groups': 'VIEW_USER_GROUPS_LIST',
    '/agencies-reference': 'VIEW_AGENCY_LIST',
    '/repairers': 'VIEW_REPAIRER_LIST',
    '/payment': 'VIEW_PAYMENT_LIST',
    '/planning': 'VIEW_SCHEDULE_LIST',
    '/voiture_de_remplacement': 'VIEW_VR_LIST',
    '/expertises': 'VIEW_INSPECTIONS_LIST',
    '/reparation_mission_list': 'VIEW_REPAIR_MISSIONS_LIST',
    '/investigations': 'VIEW_INVESTIGATIONS_LIST',
};

// Première route que le compte connecté a le droit d'ouvrir, ou null s'il n'en a aucune
export function firstAccessibleRoute() {
    return Object.keys(RESTRICTED_ROUTES).find((route) => hasAuthorities(RESTRICTED_ROUTES[route])) || null;
}

 